import React from 'react';
import { Store } from 'react-notifications-component';
import Notification from '../Components/Notification';

export const addNotification = ({ type, text, icon, duration = 4000 }) => {
  Store.addNotification({
    content: ({ id, notificationConfig }) => {
      return (
        <Notification
          type={type}
          text={text}
          icon={icon}
          duration={notificationConfig.dismiss.duration}
        />
      );
    },
    container: 'bottom-right',
    animationIn: ['animate__animated', 'animate__slideInRight'],
    animationOut: ['animate__animated', 'animate__fadeOut'],
    dismiss: {
      duration: duration,
      waitForAnimation: true,
    },
  });
};
